import { render, staticRenderFns } from "./AdvancedItemImageCarousel.vue?vue&type=template&id=05bfb87e&scoped=true"
import script from "./AdvancedItemImageCarousel.vue?vue&type=script&lang=js"
export * from "./AdvancedItemImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./AdvancedItemImageCarousel.vue?vue&type=style&index=0&id=05bfb87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfb87e",
  null
  
)

export default component.exports